import { ReactElement, useEffect, useState } from "react";
import { IBarChartConfig, IGaugeConfig, ILineChartConfig, IPieConfig } from "../../components/charts/types";
import ProductionProgress from "./components/productionProgress";
import ComponentA from "./components/componentA";
import ComponentB from "./components/componentB";
import ComponentC from "./components/componentC";
import { IDetailProps, IFilterData, IState } from "../../types";
import { Typography } from "@mui/material";
import CardBase from "../../components/widgets/cardBase";
import FilterComponentBase from "../../components/filterComponentBase";
import Detail from "../../components/dialogs/detail";
import ComponentD from "./components/componentD";
import BarChart from "../../components/charts/barChart";
import LineChart from "../../components/charts/lineChart";
import { getPalette } from "../../configuration/configuration";
import { useSelector } from "react-redux";

const oneHundred = 100;
const getRandomNumber = () => Math.random() * oneHundred;

const ProductionPage = (): ReactElement => {
  const filter = useSelector<IState, IFilterData>(state => state.filter);
  const [ openDetail, setOpenDetail] = useState<boolean>(false);

  useEffect(() => {
    console.log(filter);
  }, [filter]);

  const gaugeConfig: IGaugeConfig = {
    minimum: 0,
    maximum: 100,
    start: 225,
    length: 270,
    segments: [
      { start: 0, end: 79.5, color: "#d84315" },
      { start: 80, end: 89.5, color: "#ff8f00" },
      { start: 90, end: 100, color: "#2e7d32" }
    ]
  };

  const pieConfig: IPieConfig = {
    maximum: 0,
    padAngle: 0.05,
    innerRadius: 0.1,
    seriesRadius: 1.2,
    series: [
      { name: "A", value: 25, color: "#3e8ef7" },
      { name: "B", value: 40, color: "#0bb2d4" },
      { name: "C", value: 35, color: "#17b3a3" }
    ]
  };

  const pieConfig2: IPieConfig = {
    maximum: 1000,
    padAngle: 0.05,
    innerRadius: 0.5,
    seriesRadius: 1.2,
    series: [
      { name: "A", value: 250, color: "#3e8ef7" },
      { name: "B", value: 340, color: "#0bb2d4" },
      { name: "C", value: 170, color: "#17b3a3" }
    ]
  };

  const barChartConfig: IBarChartConfig = {
    width: 600,
    height: 100,
    xAxis: {
      name: "X",
      categories: ["Product A", "Product B", "Product C", "Product D", "Product E", "Product F"]
    },
    yAxis: [{
      name: "Y",
      minimum: 0,
      maximum: 400,
      ticksCount: 3,
      formatTick: (value) => (value as number).toFixed(2)
    }],
    title: "Bar Chart",
    series: [
      { name: "Product A", value: 250, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.indigo },
      { name: "Product B", value: 340, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.cyan },
      { name: "Product C", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.deepPurple },
      { name: "Product D", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.orange },
      { name: "Product E", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.lime },
      { name: "Product F", value: 170, xAxisName: "X", yAxisName: "Y", color: getPalette().charts.pink }
    ]
  };

  const lineChartConfig: ILineChartConfig = {
    // width: 300,
    height: 100,
    xAxis: {
      name: "X",
      minimum: 0,
      maximum: 50,
      ticksCount: 6,
      formatTick: (value) => (value as number).toFixed(2)
    },
    yAxis: [{
      name: "Y",
      minimum: 0,
      maximum: 100,
      ticksCount: 3,
      formatTick: (value) => (value as number).toFixed(2)
    }],
    title: "Line Chart",
    series: [
      { name: "A",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.pink,
        type: "area"
      },
      { name: "B",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.lightBlue,
      },
      { name: "C",
        xAxisName: "X", yAxisName: "Y",
        value: [ { x: 0, y: getRandomNumber() }, { x: 10, y: getRandomNumber() }, { x: 20, y: getRandomNumber() }, { x: 30, y: getRandomNumber() }, { x: 40, y: getRandomNumber() }, { x: 50, y: getRandomNumber() } ],
        color: getPalette().charts.purple,
      }
    ]
  };

  const detail: IDetailProps = {
    title: "Demo - Detail",
    children: <Typography variant="h3">
       Content...
    </Typography>
  };

  const detailOEE: IDetailProps = {
    title: "OEE - Detail",
    children: <div style={{ width: 400 }}>
      {/*<InterruptionChart beginShift={mockData.beginShift} endShift={mockData.endShift} data={mockData.mockData}*/}
      {/*                                  selected={selected} setSelected={setSelected}/>*/}
    </div>
  };

  // const onSelectedInterruption = (data: IDelay) => {
  //   setSelected(data);
  //   setOpenDetail(true);
  // }

  return (
    <div className="display-flex-column">
      <FilterComponentBase loading={false} />

      <div className="display-flex-row flex-wrap justify-content-space-around w-100">
        <ComponentB gaugeConfig={gaugeConfig} value={73.1} title="OEE" detail={detailOEE}/>
        <ComponentB gaugeConfig={gaugeConfig} value={86} title="Quality" detail={null}/>
        <ComponentB gaugeConfig={gaugeConfig} value={88.9} title="Availability" detail={null}/>
        <ComponentB gaugeConfig={gaugeConfig} value={94.9} title="Efficiency" detail={null}/>
        <ComponentC pieConfig={pieConfig} title="XXX" detail={null}/>
        <ComponentC pieConfig={pieConfig2} title="YYY" detail={null}/>
        <ComponentA title={"XXX"} value={123.34} diff={-10.56} points={[getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber()]} detail={null}/>
        <ComponentA title={"XXX"} value={123.34} diff={10.56} points={[getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber(), getRandomNumber()]} detail={detail} />
      </div>

      <ComponentD heatNumber={53163310} title="Heat Information" />

      <div className="display-flex-row flex-wrap justify-content-space-around w-100">
        <CardBase title={"Process XXX"} detail={detailOEE}>
          <p>TITLE</p>
        </CardBase>
        <CardBase title={"Process Events"} detail={null}>
          <>
            {/*<InterruptionChart beginShift={mockData.beginShift} endShift={mockData.endShift} data={mockData.mockData}*/}
            {/*                   selected={selected} setSelected={onSelectedInterruption}/>*/}
            {openDetail &&
              <Detail title={"Interruption Detail"} closed={() => setOpenDetail(false)}>
                <ComponentA title={"XXX"} value={123.34} diff={10.56} points={[10, 18, 20, 25, 23, 15]} detail={detail} />
              </Detail>
            }
          </>
        </CardBase>
        <CardBase title={"Product Quantity"} detail={null}>
          <ProductionProgress key="product-progress" actual={3700} expected={4200} target={9000} />
        </CardBase>
      </div>
      <div className="display-flex-row flex-wrap justify-content-space-around w-100">
        <CardBase title={"Charts"} detail={null}>
          <BarChart barChartConfig={barChartConfig}/>
        </CardBase>

        <CardBase title={"Line Chart"} detail={null}>
          <LineChart lineChartConfig={lineChartConfig}/>
        </CardBase>
      </div>
    </div>
  );

};

export default ProductionPage;
